import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Radio } from 'lucide-react';
import { useOfficeRead } from '../../hooks/useOfficePresence';
import './ResellerAccess.css';

export default function ResellerPresenceBadge({ user, onNavigate }) {
  const allowed = user?.role === 'admin';
  const { data, error } = useOfficeRead('/office/reseller-presence', user?.id, allowed);
  if (!allowed) return null;
  const available = !error && Number.isInteger(data?.online) && data.online >= 0;
  return (
    <Link to="/gestor-xui/resellers?tab=access&access=online" onClick={onNavigate}
      className="office-presence-link" data-testid="reseller-presence-badge" data-available={available}
      title="Presença no Office · atualização a cada 30 s · tolerância de 90 s. Não inclui acessos do administrador como revenda.">
      <Radio size={14} aria-hidden />
      <span aria-live="polite">{available ? <><strong>{data.online.toLocaleString('pt-BR')}</strong> revendedores online</> : error ? 'Online indisponível' : 'Verificando online…'}</span>
      <ChevronRight size={13} aria-hidden />
    </Link>
  );
}
